export default () => (
	<div class="rias-content col-span-full  mx-auto px-4 pb-8">
		<h1 class="headline-lg mb-6">Definitions</h1>

		<p class="mb-6 text-gray-700 leading-relaxed">
			The following are definitions of some of the terminology used within this website
		</p>

		<h2 class="headline-lg mb-6">Approved Body</h2>
		<p class="mb-6 text-gray-700 leading-relaxed">
			A firm, public body, or other organisation that employs at least one Approved Certifier
			of Design, operates systems to check compliance with{" "}
			<em>Building (Scotland) Regulations 2004 and subsequent amendments</em>, holds
			appropriate insurances and provides access for Approved Certifiers of Design to
			up-to-date regulations, codes, guidance, and training. Approved Bodies approved by a
			Scheme Provider must appoint a Certification Coordinator who countersigns Certificates
			of Design issued by an Approved Certifier of Design.
		</p>

		<h2 class="headline-lg mb-6">Approved Certifier of Design</h2>
		<p class="mb-6 text-gray-700 leading-relaxed">
			An individual with the appropriate understanding of their role, the qualifications and
			the experience required to certify that specified aspects of design comply with the
			Technical Standards approved by Scottish Ministers in accordance with the{" "}
			<em>Building (Scotland) Regulations 2004</em> and subsequent amendments. Approved
			Certifiers of Design may be approved by a Scheme Provider under Section 7(2) of the Act
			or by the Scottish Ministers under Section 7(1). They may only issue Certificates of
			Design that are counter-signed by a Certification Coordinator on behalf of an Approved
			Body. They must keep a record of all the Certificates of Design that they issue, along
			with copies of the design to which they refer.
		</p>

		<h2 class="headline-lg mb-6">Certificates of Design</h2>
		<p class="mb-6 text-gray-700 leading-relaxed">
			A building owner/developer may use a Certificate of Design to support an application for
			a building warrant. A Certificate of Design certifies that the design described in the
			building warrant application complies with one or more of the functional Standards
			listed in schedule 5 to regulation 9 of the{" "}
			<em>Building (Scotland) Regulations 2004</em> and subsequent amendments. The Certificate
			is only valid under the Act when issued by an Approved Certifier of Design. Each
			Certificate of Design issued by an Approved Certifier of Design must be counter-signed
			by the Certification Coordinator of an Approved Body that belongs to the same Scheme.
		</p>

		<h2 class="headline-lg mb-6">Certification Coordinator</h2>
		<p class="mb-6 text-gray-700 leading-relaxed">
			An individual responsible for signing Certificates of Design on behalf of an Approved
			Body. The Certification Coordinator acts as the contact point for the Approved Body and
			is responsible for maintaining the system of checking, insurance, policies, access to
			documents, training, and handling complaints for that Approved Body.
		</p>

		<h2 class="headline-lg mb-6">Scheme Provider</h2>
		<p class="mb-6 text-gray-700 leading-relaxed">
			An organisation that operates one or more Schemes to certify compliance with the{" "}
			<em>Building (Scotland) Regulations 2004</em> and subsequent amendments for specified
			aspects of a project. The Building Standard Division (BSD) of the Scottish Government
			criteria for approval of Scheme Providers include evidence of status, expertise in
			relevant aspects of design or construction, capacity to operate schemes, financial
			probity, and appropriate disciplinary procedures.
		</p>

		<h2 class="headline-lg mb-6">Verifier</h2>
		<p class="mb-6 text-gray-700 leading-relaxed">
			Verifiers are appointed to verify that work complies with the{" "}
			<em>Building (Scotland) Regulations 2004, and subsequent amendments,</em> both in terms
			of design and construction. Scottish Ministers have appointed the 32 Local Authorities
			in Scotland as Verifiers. The work of verification will usually be undertaken by their
			Building Standards Departments. Verifiers undertake “necessary checks” before verifying
			applications for building warrants and must make “reasonable enquiry” to assess whether
			Completion Certificates should be accepted when the works are complete.
		</p>
		<p class="mb-6 text-gray-700 leading-relaxed">
			They must accept Certificates of Design issued by registered Approved Certifiers of
			Design as conclusive of the matters certified. Verifiers are not required to scrutinise
			certified matters further and are only expected to check that the Approved Certifier of
			Design and the Approved Body were appropriately registered on the date the Certificate
			of Design was signed.
		</p>
	</div>
);
